import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/users/secret/key',
    name: 'secretGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec];
})